import { ThemedText } from "@app/theme";
import { ThemedView } from "@app/theme";
import Button from "@app/sharedComponents/Button/Button"
import ROUTE from "@app/navigationApp/routes";



const ChargesInfo = ({accountOpeningFee, navigation, closeBottomSheet}: {accountOpeningFee: number, navigation: any, closeBottomSheet: () => void}) => {
    return (
        <ThemedView p="lg">
            <ThemedText variant="h5s" color="text-primary">Outstanding charges</ThemedText>
            <ThemedView mt="xl" p="md" backgroundColor="bg-fill-info" borderRadius="sm" mb="lg">
                <ThemedText variant="b4r" color="text-primary">There are outstanding charges of ₹{accountOpeningFee} on your loan account.</ThemedText>
                <ThemedText variant="b4r" color="text-primary" mt="lg">Details of charges are available in account statement. To view details, 
                    <ThemedText variant="b4s" color='text-action-primary' onPress={()=>navigation.navigate(ROUTE.TRANSACTION_SCREEN)}> click{'\u00A0'}here</ThemedText>
                </ThemedText>
            </ThemedView>
            <Button label="Ok, got it!" type="SOLID" handlePress={closeBottomSheet}/>
        </ThemedView>
    )
}

export default ChargesInfo;